import React from 'react';

import { colorsPalette } from '../../theme';
import useStyles from './styles';

const ChevronLeftIcon = (props) => {
  const color = props?.color || colorsPalette.white;
  const classes = useStyles()();

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
      color={color}
    >
      <polyline className={classes.element} points="17 22 7 12 17 2" />
    </svg>
  );
};

export default ChevronLeftIcon;
